module.exports = __webpack_public_path__ + "assets/6660f0de94480dd93c14d79f881feee3.svg";